import React from "react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle, faSpinner } from "@fortawesome/free-solid-svg-icons";




function NoneSelectedMessage(props){

    return (
    <div style={{height:"469px",padding:"5px",paddingTop:"10px", color: "#3B5158"}}> 
    <FontAwesomeIcon pulse={props.icon==="loading"} icon={props.icon === "loading"? faSpinner : faInfoCircle} style={{marginRight: 4}}/> 
    <span style={{fontWeight:"bold"}}>{props.message}</span>
    </div>)
}

export {NoneSelectedMessage}